import { createAsyncThunk } from '@reduxjs/toolkit';

export const onToggleDisplayArchive = createAsyncThunk(
  'onToggleDisplayArchive',
  async (
    data: { action?: boolean },
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    if (data && data.action !== null) {
      return { action: data.action };
    } else {
      return;
    }
  }
);

export default onToggleDisplayArchive;
